var stylesheetUrl = data.stylesheetUrl;

export const MobileMenu = {
  config: {},
  toggleNav: function () {
    var mobileMenu = MobileMenu.config.toggles.mobileMenu;
    var body = MobileMenu.config.toggles.body;

    MobileMenu.setHeaderOffset();
    mobileMenu.el.toggleClass(mobileMenu.classToggle);
    body.el.toggleClass(body.classToggle);

    var menuIsOpen = mobileMenu.el.hasClass(mobileMenu.classToggle);
    MobileMenu.config.targets.mobileMenuIcon.attr("aria-expanded", menuIsOpen);
    MobileMenu.config.targets.mobileMenuIcon.attr(
      "aria-label",
      menuIsOpen ? "Close mobile menu" : "Open mobile menu"
    );

    window.setTimeout(MobileMenu.setHeaderOffset, 250);
  },
  toggleSubNav: function (parent) {
    parent.toggleClass("active");
    parent.children(".sub-menu").slideToggle(500);
  },
  setHeaderOffset: function () {
    var siteHeader = document.querySelector(".site-header");
    var headerBottom = siteHeader
      ? Math.ceil(siteHeader.getBoundingClientRect().bottom)
      : 0;

    document.documentElement.style.setProperty(
      "--mobile-menu-offset",
      Math.max(headerBottom, 0) + "px"
    );
  },
  setUpIcons: function () {
    var ajax = new XMLHttpRequest();
    var closeIconContainer =
      MobileMenu.config.targets.mobileMenuCloseIconContainer;

    if (!closeIconContainer.length) {
      return;
    }

    ajax.open("GET", stylesheetUrl + "/assets/icons/close.svg", true);
    ajax.send();
    ajax.onload = function (e) {
      closeIconContainer.html(ajax.responseText);
    };
  },
  init: function (template_url, configObj) {
    configObj = configObj || { toggles: {}, targets: {}, flags: {} };
    configObj.toggles.mobileMenu = configObj.toggles.mobileMenu || {
      el: jQuery(".mobile-menu"),
      classToggle: "move-in",
    };
    configObj.toggles.body = configObj.toggles.body || {
      el: jQuery("body"),
      classToggle: "locked",
    };

    configObj.targets.mobileMenuIcon =
      configObj.targets.mobileMenuIcon || jQuery(".mobile-menu-icon");
    configObj.targets.mobileMenuCloseIconContainer =
      configObj.targets.mobileMenuCloseIconContainer ||
      configObj.toggles.mobileMenu.el.find(".icon-close-container");

    configObj.templateUrl = configObj.templateUrl || template_url || "";

    MobileMenu.config = configObj;

    MobileMenu.setHeaderOffset();
    MobileMenu.config.targets.mobileMenuIcon.on("click", MobileMenu.toggleNav);
    MobileMenu.config.targets.mobileMenuCloseIconContainer.on(
      "click",
      MobileMenu.toggleNav
    );
    jQuery(window).on("resize orientationchange", MobileMenu.setHeaderOffset);
    jQuery(".mobile-menu .menu")
      .children("li.menu-item-has-children")
      .children("a")
      .on("click", function (e) {
        var $parent = jQuery(this).parent();
        // If submenu is not yet open, prevent navigation and just open it
        if (!$parent.hasClass("active")) {
          e.preventDefault();
          MobileMenu.toggleSubNav($parent);
        }
        // If already open, allow navigation (don't prevent default)
      });

    MobileMenu.setUpIcons();
  },
};
